import { types } from '../../../constants/ActionTypes'
import { accountSettings as limit } from '../../../constants/Limit'
import { deepCopy } from '../../../lib'

const initialState = {
  settings: {
    avatarPhotoURL: '',
    headerPhotoURL: '',
    userName: '',
    displayName: '',
    rank: '',
    country: '',
    city: '',
    birthday: '',
    profileHTML: '',
  },
  error: {
    profileHTML: false,
    hasSameUserName: false,
  },
  result: {},
  isSaving: false,
}

const accountSettingsCard = (state = deepCopy(initialState), action) => {
  var error, result
  switch (action.type) {
    case types.accountSettingsCard.INIT:
      return { ...state, settings: { ...state.settings, ...action.settings } }
    case types.accountSettingsCard.UNMOUNT:
      return { ...deepCopy(initialState) }
    case types.accountSettingsCard.CHANGED_PHOTO:
      return { ...state, settings: { ...state.settings, [action.name]: action.data } }
    case types.accountSettingsCard.CHANGED_TEXT:
      error = {}
      switch(action.name) {
        case 'userName':
          if (
            action.text.length > limit.stringLength.userName ||
            Boolean(action.text.match(limit.format.userName))
          ) {
            return state
          }
          error.hasSameUserName = false
          break
        case 'displayName':
          if (action.text.length > limit.stringLength.displayName) {
            return state
          }
          break
        case 'city':
          if (action.text.length > limit.stringLength.city) {
            return state
          }
          break
        case 'profileHTML':
          error.profileHTML = Boolean(action.text.length > limit.stringLength.profileHTML)
          break
        default:
          break
      }
      return {
        ...state,
        settings: { ...state.settings, [action.name]: action.text },
        error: { ...state.error, ...error }
      }
    case types.accountSettingsCard.RESPONSE_UPLOAD_AVATAR:
      return {
        ...state,
        settings: {
          ...state.settings,
          avatarPhotoURL: action.response.photoURL,
        },
        result: {
          ...state.result,
          avatarPhotoURL: action.response.result
        }
      }
    case types.accountSettingsCard.RESPONSE_UPLOAD_HEADER:
      return {
        ...state,
        settings: {
          ...state.settings,
          headerPhotoURL: action.response.photoURL,
        },
        result: {
          ...state.result,
          headerPhotoURL: action.response.result
        }
      }
    case types.accountSettingsCard.RESPONSE_UPDATE_DISPLAYNAME:
      return {
        ...state,
        settings: {
          ...state.settings,
          displayName: action.response.displayName,
        },
        result: {
          ...state.result,
          displayName: action.response.result,
        }
      }
    case types.accountSettingsCard.RESPONSE_UPDATE:
      result = {}
      action.targets.forEach((key) => {
        result[key] = action.response.result
      })
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.response.settings,
        },
        result: {
          ...state.result,
          ...result,
        },
        error: {
          ...state.error,
          hasSameUserName: action.response.hasSameUserName,
        }
      }
    case types.accountSettingsCard.START_SAVE:
      return { ...state, isSaving: true, result: {} }
    case types.accountSettingsCard.END_SAVE:
      return { ...state, isSaving: false }
    default:
      return state
  }
}

export default accountSettingsCard



// WEBPACK FOOTER //
// ./src/reducers/Page/Settings/AccountSettingsCard.js